import { FileType } from '@office-start/document-types';
import { createPromiseCancellationToken } from '@office-start/models-utility';
import { UploadStatus } from '@office-start/upload-types';
import { useCallback } from 'react';
import { useGetUploadFileType } from './useGetUploadFileType';
import { useUploadState } from './useUploadState';
export var useUploadFileDirect = function () {
    var _a = useUploadState(), addFileUploadState = _a.addFileUploadState, setShowUploadFileUnsupportedDialog = _a.setShowUploadFileUnsupportedDialog, uploadState = _a.uploadState;
    var getFileType = useGetUploadFileType();
    return useCallback(function (_a) {
        var area = _a.area, file = _a.file, source = _a.source;
        if (!file) {
            return;
        }
        if (getFileType(file.name) === FileType.None) {
            setShowUploadFileUnsupportedDialog(true);
            return;
        }
        addFileUploadState({
            sequenceNumber: uploadState.nextSequenceNumber,
            file: file,
            uploadStatus: UploadStatus.Started,
            progress: 0,
            cancellationToken: createPromiseCancellationToken(),
            telemetry: {
                area: area,
                source: source,
            },
        });
    }, [
        addFileUploadState,
        getFileType,
        setShowUploadFileUnsupportedDialog,
        uploadState.nextSequenceNumber,
    ]);
};
//# sourceMappingURL=useUploadFileDirect.js.map